import { adminApiFetch } from './apiService';

export const shipmentService = {
  // 列表 (POST) - 用於 TableIndex
  getRecords: async (params) => {
    const response = await adminApiFetch('shipments/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await adminApiFetch('shipments/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 測試列印標籤
  testPrintLabel: async (orderId) => {
    const response = await adminApiFetch('shipments/test_print_label', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ order_id: orderId }),
    });
    return response.json();
  },

  // 刪除出貨單
  delete: async (shipmentId) => {
    const response = await adminApiFetch(`shipments/${shipmentId}`, {
      method: 'DELETE',
    });
    return response.json();
  },

  // 恢復出貨單
  restore: async (shipmentId) => {
    const response = await adminApiFetch(`shipments/${shipmentId}/restore`, {
      method: 'POST',
    });
    return response.json();
  },

  // 取得 execute_html 託運單的簽章 URL（用於 window.open 繞過主站 CSP）
  executeHtmlUrl: async (shipmentId) => {
    const response = await adminApiFetch(`shipments/${shipmentId}/execute_html_url`, {
      method: 'POST',
    });
    return response.json();
  },

  // 匯出
  export: async (ids, params = {}) => {
    const response = await adminApiFetch('shipments/export', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids, ...params })
    });
    return response.json();
  },
};
export default shipmentService;
